module.exports = __webpack_public_path__ + "cover-letter-47f61a13/template-6-2x-1e673c1fdba65ea306a49e294dc09e8a.jpg";